import { render, staticRenderFns } from "./ViewError.vue?vue&type=template&id=05a95aee&"
import script from "./ViewError.vue?vue&type=script&lang=js&"
export * from "./ViewError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports